



















































import { Vue, Component } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

const ns = 'masterPassword';

@Component
export default class MasterPasswordLock extends Vue {
  @Getter(`${ns}/isConfigured`) private isConfigured!: boolean;
  @Action(`${ns}/setupMasterPassword`) private setupMasterPassword: any;
  @Action(`${ns}/unlockWithPassword`) private unlockWithPassword: any;
  @Action(`${ns}/forgotPassword`) private forgotPassword: any;

  private newPassword: string = '';
  private confirmPassword: string = '';
  private unlockPassword: string = '';
  private error: string = '';
  private loading: boolean = false;
  private showForgotConfirm: boolean = false;

  private get title(): string {
    if (this.showForgotConfirm) { return 'Reset Master Password'; }
    return this.isConfigured ? 'Unlock App' : 'Set Up Master Password';
  }

  private mounted() {
    this.$nextTick(() => {
      const input = this.$refs.passwordInput as any;
      if (input) { input.focus(); }
    });
  }

  private async handleSetup() {
    this.error = '';
    if (!this.newPassword.trim()) {
      this.error = 'Password cannot be empty.';
      return;
    }
    if (this.newPassword !== this.confirmPassword) {
      this.error = 'Passwords do not match.';
      return;
    }
    this.loading = true;
    try {
      await this.setupMasterPassword(this.newPassword);
    } catch (e) {
      this.error = (e as any).message || 'Failed to set master password.';
    }
    this.loading = false;
  }

  private async handleUnlock() {
    this.error = '';
    if (!this.unlockPassword) {
      this.error = 'Please enter your master password.';
      return;
    }
    this.loading = true;
    const success = await this.unlockWithPassword(this.unlockPassword);
    this.loading = false;
    if (!success) {
      this.error = 'Incorrect master password.';
      this.unlockPassword = '';
    }
  }

  private handleForgotPassword() {
    this.forgotPassword();
    this.showForgotConfirm = false;
    this.error = '';
    this.newPassword = '';
    this.confirmPassword = '';
  }
}
